/**
 * Generates cryptographically strong v4 UUID--random hexadecimal values in a 36 character long string.
 * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
 * For use as a transaction id in services like /authenticate.
 * @returns str - 36 character long random string, hyphenated in v4 UUID format or empty str if crypto web api does not exist
 */
const generateTransId = () => {
    var _a, _b;
    return (_b = (_a = window === null || window === void 0 ? void 0 : window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID()) !== null && _b !== void 0 ? _b : '';
};
export default generateTransId;
